import axios from 'axios'
import {getAdminToken} from '../../auth/_requests'
import {BulkResult, BulkScope, PacingResponse} from './_models'

const API_URL = process.env.REACT_APP_API_URL
const BASE = `${API_URL}/admin/post-pacing`

const adminApi = axios.create({withCredentials: true})
adminApi.interceptors.request.use((config) => {
  const token = getAdminToken()
  if (token && config.headers) config.headers.Authorization = `Bearer ${token}`
  return config
})

export function getPostPacing(params: {
  threshold?: number
  all?: boolean
  q?: string
  date?: string
}): Promise<{data: PacingResponse}> {
  return adminApi.get(BASE, {
    params: {
      threshold: params.threshold,
      all: params.all ? 1 : undefined,
      q: params.q || undefined,
      date: params.date || undefined,
    },
  })
}

export function setSpreadBulk(
  enabled: boolean,
  scope: BulkScope,
  opts: {accountIds?: string[]; minPct?: number} = {}
): Promise<{data: BulkResult}> {
  return adminApi.post(`${BASE}/spread-bulk`, {
    enabled,
    scope,
    account_ids: opts.accountIds,
    min_pct: opts.minPct,
  })
}

export function setSpreadForAccount(accountId: string, enabled: boolean): Promise<{data: any}> {
  return adminApi.put(`${BASE}/account/${accountId}/spread`, {enabled})
}
